
import { useCallback } from "react";
import { TimeSlot } from "./types";
import { CalendarEvent } from "@/hooks/calendar/types";

export const useTimeSlotSelection = (
  setSelectedTimeSlot: (slot: TimeSlot | null) => void,
  getEventsForDateAndHour: (date: Date, hour: number) => CalendarEvent[],
  setConflictingEvents: (events: CalendarEvent[]) => void,
  setIsConflictDialogOpen: (open: boolean) => void,
  setIsPastTimeSlotDialogOpen: (open: boolean) => void,
  setIsBookingDialogOpen: (open: boolean) => void,
  setIsClientRequestDialogOpen: (open: boolean) => void,
  isTimeSlotInPast: (date: Date, hour: number) => boolean,
  isClientView: boolean,
  onAddEvent?: (event: Omit<CalendarEvent, "id">) => Promise<void>
) => {
  const handleTimeSlotClick = useCallback((date: Date, hour: number) => {
    if (!onAddEvent) return;
    
    setSelectedTimeSlot({ date, hour });
    
    // Verifica se lo slot di tempo è nel passato
    if (isTimeSlotInPast(date, hour)) {
      setIsPastTimeSlotDialogOpen(true);
      return;
    }
    
    const existingEvents = getEventsForDateAndHour(date, hour);
    
    if (existingEvents.length > 0) {
      setConflictingEvents(existingEvents);
      setIsConflictDialogOpen(true);
    } else {
      if (isClientView) {
        setIsClientRequestDialogOpen(true);
      } else {
        setIsBookingDialogOpen(true);
      }
    }
  }, [
    onAddEvent, 
    setSelectedTimeSlot, 
    isTimeSlotInPast, 
    getEventsForDateAndHour, 
    setConflictingEvents, 
    setIsConflictDialogOpen, 
    setIsPastTimeSlotDialogOpen, 
    setIsBookingDialogOpen, 
    setIsClientRequestDialogOpen, 
    isClientView
  ]);

  return {
    handleTimeSlotClick
  };
};
